import { combineReducers } from 'redux';
import {
  RENAME_DESIGN,
  STATE_ARTWORK_INFO,
  STATE_ARTWORK_PROJECT,
  STATE_ARTWORK_PRODUCT_DATA,
  STATE_ARTWORK_IMAGE,
  STATE_ARTWORK_PAPER_MATERIAL,
  RESET_ARTWORK_INFO,
  RESET_ARTWORK_PROJECT,
  RESET_ARTWORK_PRODUCT_DATA,
  RESET_ARTWORK_IMAGE,
  RESET_ARTWORK_PAPER_MATERIAL,
} from '@app/actions/_types';

const initialArtworkProjectState = null;
const initialArtworkProductData = null;

const initialArtworkImageState = null;
const initialArtworkPaperMaterialState = null;

const initialArtworkInfoState = {
  artwork_file_type: null,
  artwork_filename: null,
  artwork_pdf_url: null,
  designName: undefined,
  artwork_status: null,
  check_design: null,
  preview_urls: null,
  artwork_url: null,
  artwork_id: null,
  file: null,
  name: null,
};

const artworkInfoReducer = (state = initialArtworkInfoState, { type, payload } = {}) => {
  switch (type) {
    case RESET_ARTWORK_INFO:
      return initialArtworkInfoState;
    case STATE_ARTWORK_INFO:
      return { ...state, ...payload };
    case RENAME_DESIGN:
      return { ...state, designName: payload };
    default:
      return state;
  }
};

const artworkProductDataReducer = (state = initialArtworkProductData, { type, payload } = {}) => {
  switch (type) {
    case RESET_ARTWORK_PRODUCT_DATA:
      return initialArtworkProductData;
    case STATE_ARTWORK_PRODUCT_DATA:
      return { ...state, ...payload };
    default:
      return state;
  }
}

const artworkProjectReducer = (state = initialArtworkProjectState, { type, payload } = {}) => {
  switch (type) {
    case RESET_ARTWORK_PROJECT:
      return initialArtworkProjectState;
    case STATE_ARTWORK_PROJECT:
      return { ...state, ...payload };
    default:
      return state;
  }
};

const artworkImageReducer = (state = initialArtworkImageState, { type, payload } = {}) => {
  switch (type) {
    case RESET_ARTWORK_IMAGE:
      return initialArtworkImageState;
    case STATE_ARTWORK_IMAGE:
      return { ...state, ...payload };
    default:
      return state;
  }
};

const artworkPaperMaterialReducer = (state = initialArtworkPaperMaterialState, { type, payload } = {}) => {
  switch (type) {
    case RESET_ARTWORK_PAPER_MATERIAL:
      return initialArtworkPaperMaterialState;
    case STATE_ARTWORK_PAPER_MATERIAL:
      return { ...state, ...payload };
    default:
      return state;
  }
};

export default combineReducers({
  project: artworkProjectReducer,
  image: artworkImageReducer,
  paperMaterial: artworkPaperMaterialReducer,
  info: artworkInfoReducer,
  product: artworkProductDataReducer,
});
